// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__hOq3Q"};